import { atom } from 'jotai';
import { AuthError } from 'src/types/auth';

export const authErrorAtom = atom<AuthError>({
  type: '',
  description: '',
});
